<mat-toolbar class="topbar-content">
  <div>
    <button type="button" mat-button >
      <img src="../../assets/img/logo.png">
    </button>
  </div>
</mat-toolbar>
<div style="padding: 16px;" innerHTML="{{ 'privacy_content' | translate}}"></div>
